import React from 'react';

import { Card, CardSection, IconDocuments } from '@maiia/design-system';
import { useTranslation } from '@/src/i18n';
import ShareDocumentController from './ShareDocumentController';

const SharePrescription = props => {
  const { t } = useTranslation();

  return (
    <Card hasOldStyle>
      <CardSection icon={<IconDocuments />} title={t('services')}>
        <p>{t('share-prescription-to-pharmacy-message')}</p>
        <ShareDocumentController {...props} />
      </CardSection>
    </Card>
  );
};

export default SharePrescription;
